<app-state-section [state]="sectionState">
  <app-dialog-layout class="bg-white">
    <ng-container dialog-title>{{ 'AddShipment.AddContact' | translate }}</ng-container>

    <form *ngIf="form" [formGroup]="form" class="mt-3">
      <div class="brd-t brd-b brd-300 py-3 flex column gap-2">
        <div formArrayName="contacts" class="flex column gap-3">
          <div
            *ngFor="let row of contactsArray.controls; let i = index"
            [formGroupName]="i"
            class="flex gap-3 align-flex-start"
          >
            <!-- Full name -->
            <div class="box grow-fixed">
              <app-form-field-group>
                <mat-form-field appearance="outline" class="w-100">
                  <input matInput type="text" [placeholder]="'Inputs.FullName' | translate" formControlName="fullName" />
                </mat-form-field>
              </app-form-field-group>

              <mat-error
                class="small mt-1"
                *ngIf="row.get('fullName').touched && row.get('fullName').hasError('required')"
              >
                {{ 'ErrorMessages.Required' | translate }}
              </mat-error>
              <mat-error
                class="small mt-1"
                *ngIf="row.get('fullName').touched && row.get('fullName').hasError('whitespace')"
              >
                {{ 'ErrorMessages.InValidData' | translate }}
              </mat-error>
            </div>

            <!-- Country code + mobile number, joined into a single bordered control -->
            <div class="box grow-fixed">
              <app-phone-number-field formControlName="phone" [countries]="countries"></app-phone-number-field>
            </div>

            <div class="box nogrow" *ngIf="contactsArray.length > 1">
              <button
                mat-icon-button
                type="button"
                class="bg-warn-lighter text-warn radius-2"
                [attr.aria-label]="'Buttons.Delete' | translate"
                (click)="removeContact(i)"
              >
                <app-icon name="outline-minus" size="xs"></app-icon>
              </button>
            </div>
          </div>
        </div>

        <!-- wrapper keeps the button at its content width, flush with the column above -->
        <div>
          <button mat-button type="button" class="p-0 h-auto text-accent weight-normal" (click)="addAnotherContact()">
            <span class="flex align-center gap-1">
              <app-icon name="outline-add" size="sm" class="m-0 p-0"></app-icon>
              <span>{{ 'AddShipment.AddAnotherContact' | translate }}</span>
            </span>
          </button>
        </div>
      </div>

      <div class="flex gap-3 justify-flex-end mt-3">
        <button mat-button type="button" class="bg-white brd brd-200 radius-2 text-800 px-3" (click)="cancel()">
          {{ 'Buttons.Cancel' | translate }}
        </button>
        <button
          mat-flat-button
          color="primary"
          type="button"
          class="radius-2 px-3"
          [disabled]="form.invalid"
          (click)="onConfirm()"
        >
          {{ 'Buttons.Confirm' | translate }}
        </button>
      </div>
    </form>
  </app-dialog-layout>
</app-state-section>